'use strict';
/**
 * This service provides session group scheme information, including basic contact information
 * uses session storage to cache groupScheme information
 * if request has been initiated and not yet resolved any new requests will return the promise of the first request
 * @author c_razmuss_a (Arturs Razmuss) on 16/02/2018
 */
var $ = require('jquery');
var ajaxHandler = require('shared/scripts/modules/services/ajaxHandler');
var store = require('../utils/store');

//const
var cacheKey = 'groupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getGroupScheme(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        // The case when user hasn't visited "/groups" page before "/myvhi" and there is no GroupScheme info in session
        // (can be called when displaying custom enrolment content)
        if(groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: '/groups/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(onSuccess)
                .always(onAlways);
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: '/groups/rest/scheme'})
                .then(onSuccess)
                .always(onAlways);
        }
        return fetchInProgress;
    }
    
    function onSuccess(groupSchemeBasicInfo) {
        store.session(cacheKey, groupSchemeBasicInfo);
        return groupSchemeBasicInfo;
    }

    function onAlways() {
        fetchInProgress = null;
    }
}

module.exports.getGroupScheme = getGroupScheme;
module.exports.getContactInformation = getContactInformation;



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/services/groupSchemeService.js
// module id = pHlT
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16